import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import { useCallback } from "react";

import { useMaybeAssignCategoryTreeExperiment } from "@faire/retailer/lib/useMaybeAssignCategoryTreeExperiment";

export const useMaybeAssignCategoryTreeExperimentForFilterSection = () => {
  const maybeAssignCategoryTreeExperiment =
    useMaybeAssignCategoryTreeExperiment();

  return useCallback(
    (section: IFilterSection, pathIdentifiers: (string | undefined)[]) => {
      if (section.field_name === IFilterSection.FieldName.CATEGORY) {
        maybeAssignCategoryTreeExperiment(
          () => pathIdentifiers,
          IRecordCategoryNodesVisibilityRequest.Source
            .WEB_SEARCH_RESULTS_CATEGORY_FILTER
        );
      }
    },
    [maybeAssignCategoryTreeExperiment]
  );
};
